var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"currency-selector"},[_c('lv-currency-picker',{attrs:{"currencies":_vm.currencies},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }